<template>
  <v-card>
    <v-card-title class="title info--text justify-center pb-0">
      ¿QUÉ TAN SATISFECHO/A ESTÁS CON NUESTRAS RESPUESTAS?
    </v-card-title>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 md12 class="d-flex justify-center">
          Este caso fue cerrado. Te invitamos a contestar esta breve encuesta de satisfacción
        </v-flex>
        <v-flex xs12 md12 mt-2>
          <v-layout row wrap>
            <v-flex class="text-center " v-for="n in 5" :key="n">
              <v-img class="mx-auto circle" :src="require(`@/assets/face_${n}.png`)" contain height="50"></v-img>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex v-for="n in 5" :key="n">
              <v-checkbox
                class="justify-center ma-0 pl-2"
                v-model="value"
                :value="n"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout row wrap >
            <v-flex v-for="n in 5" :key="n" >
              <h4 v-if="n == 1" class="p-center">Muy Insatisfecho/a</h4>
              <h4 v-if="n == 2" class="p-center">Insatisfecho/a</h4>
              <h4 v-if="n == 3" class="p-center-3">Neutral</h4>
              <h4 v-if="n == 4" class="p-center-4">Satisfecho/a</h4>
              <h4 v-if="n == 5" class="p-center-4">Muy Satisfecho/a</h4>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="info"
        text
        @click="handleCreateAnswer()"
        :disabled="!value"
      >
        Responder encuesta
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'
import Swal from "sweetalert2"

export default {
  props: {
    ticket: { type: Object, required: true },
  },
  data: () => ({
    value: null
  }),
  methods: {
    ...mapActions("helpcenter", ["createSatisfactionAnswer"]),
    showAlert() {
      return Swal.fire({
        title: "Gracias por tu respuesta.",
        icon: "success"
      })
    },
    async handleCreateAnswer() {
      const payload = { ticketId: this.ticket.id, value: this.value }
      const res = await this.createSatisfactionAnswer(payload)

      if (res.success) {
        this.value = null
        this.ticket.survey_answered = true
        this.showAlert()
      }
    }
  },
}
</script>
<style>
  .p-center{
    text-align: center;
    width: 88%;
  }
  .p-center-3{
    text-align: center;
    width: 96%;
    padding-left: 10px;
  }
  .p-center-4{
    text-align: center;
    width: 113%;
    padding-left: 10px;
  }
</style>